export const operatorData = [
  {
    operator: "contains_logged_in",
    operator_name: "Contains Logged in",
    fields: [
      "textfield",
      "email",
      "number",
      "select",
      "radio",
      "toggle",
      "checkbox",
      "date",
      "id-gen",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "string"
    ],
    value: "logged_in_user"
  },
  {
    operator: "logged_in_id",
    operator_name: "= Logged In ID",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "string"
    ],
    value: ""
  },
  {
    operator: "logged_in_roles",
    operator_name: "Matches Logged In Roles",
    fields: ["select", "json"],
    value: ""
  },
  {
    operator: "logged_in_role_positions",
    operator_name: "Matches Logged In Role Positions",
    fields: ["select", "json"],
    value: ""
  },
  {
    operator: "is_empty",
    operator_name: "Empty Field",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "array",
      "string"
    ],
    value: ""
  },
  {
    operator: "is_not_empty",
    operator_name: "Non-Empty Field",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "array",
      "string"
    ],
    value: ""
  },
  {
    operator: "logged_in_email",
    operator_name: "= Logged In Email",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "string"
    ],
    value: ""
  },
  {
    operator: "logged_in_extra",
    operator_name: "= Logged In Extra",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "string"
    ],
    value: "logged_in_extra"
  },
  {
    operator: "in_logged_in_extra",
    operator_name: "IN Logged In Extra",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "array",
      "string"
    ],
    value: "logged_in_extra"
  },
  {
    operator: "istrue",
    operator_name: "Is True",
    fields: ["checkbox", "toggle", "boolean"],
    value: "na"
  },
  {
    operator: "isfalse",
    operator_name: "Is False",
    fields: ["checkbox", "toggle", "boolean"],
    value: "na"
  },
  {
    operator: "human_date",
    operator_name: "Human Date",
    fields: ["date", "datetime"],
    value: "human_date"
  },
  {
    operator: "custom_date_range",
    operator_name: "Custom Date Range",
    fields: ["date", "datetime"],
    value: "custom_date_range"
  },
  {
    operator: "in_logged_in_team",
    operator_name: "IN Logged In Team",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "string"
    ],
    value: ""
  },
  {
    operator: "from_token",
    operator_name: "From Token",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "int",
      "string"
    ],
    value: "text_value"
  },
  {
    operator: "contains_from_token",
    operator_name: "Contains From Token",
    fields: [
      "text",
      "number",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "string"
    ],
    value: "text_value"
  },
  {
    operator: "a_contains_logged_in",
    operator_name: "Array Contains Logged In",
    fields: ["array"],
    value: "logged_in_user"
  },
  {
    operator: "a_contains_from_token",
    operator_name: "Array Contains From Token",
    fields: ["array"],
    value: "text_value"
  },
  {
    operator: "a_contains",
    operator_name: "Array Contains",
    fields: ["array"],
    value: "text_value"
  }
];

export const columnOperatorData = [
  {
    operator: "isnot",
    operator_name: "Is Not",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "masterdata-lookup",
      "string"
    ],
    value: "text_value"
  },
  {
    operator: "in_http_output",
    operator_name: "In HTTP Temp output",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "selectboxes",
      "string",
      "array",
      "json",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "number",
      "int",
      "date",
      "datetime",
      "checkbox",
      "toggle",
      "currency",
      "boolean",
      "learning-tags"
    ],
    value: "text_value"
  },
  {
    operator: "eq_http_output",
    operator_name: "Equals HTTP Temp output (case-insensitive)",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "selectboxes",
      "string",
      "array",
      "json",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "id-gen",
      "number",
      "int",
      "date",
      "datetime",
      "checkbox",
      "toggle",
      "currency",
      "boolean",
      "learning-tags"
    ],
    value: "text_value"
  },
  {
    operator: "in",
    operator_name: "In",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "selectboxes",
      "masterdata-lookup",
      "string"
    ],
    value: "text_array"
  },
  {
    operator: "contains",
    operator_name: "Contains",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "masterdata-lookup",
      "string"
    ],
    value: "text_value"
  },
  {
    operator: "=",
    operator_name: "Equals To",
    fields: ["number", "int", "currency"],
    value: "number_value"
  },
  {
    operator: "!=",
    operator_name: "Not Equals To",
    fields: ["number", "int", "currency"],
    value: "number_value"
  },
  {
    operator: ">",
    operator_name: "Greater Than",
    fields: ["number", "int", "currency"],
    value: "number_value"
  },
  {
    operator: ">=",
    operator_name: "Greater Than Equals To",
    fields: ["number", "int", "currency"],
    value: "number_value"
  },
  {
    operator: "<",
    operator_name: "Less Than",
    fields: ["number", "int", "currency"],
    value: "number_value"
  },
  {
    operator: "<=",
    operator_name: "Less Than Equals To",
    fields: ["number", "int", "currency"],
    value: "number_value"
  },
  {
    operator: "between",
    operator_name: "Between",
    fields: ["number", "int", "currency"],
    value: "number_range"
  },
  {
    operator: "is",
    operator_name: "Is",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "masterdata-lookup",
      "string"
    ],
    value: "text_value"
  },
  {
    operator: "is_not_instance_fv",
    operator_name: "Is Not SM Field Value",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "masterdata-lookup",
      "number",
      "id-gen",
      "learning-tags",
      "int",
      "string"
    ],
    value: "instance_value"
  },
  {
    operator: "is_instance_fv",
    operator_name: "= SM field value",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "masterdata-lookup",
      "number",
      "id-gen",
      "learning-tags",
      "int",
      "string"
    ],
    value: "instance_value"
  },
  {
    operator: "in_rdbms_group",
    operator_name: "In RDBMS group",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "select",
      "learning-text",
      "masterdata-lookup",
      "number",
      "id-gen",
      "string"
    ],
    value: "rdbms_value"
  },
  {
    operator: "exists",
    operator_name: "Exists",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "number",
      "int",
      "currency",
      "id-gen",
      "string"
    ],
    value: ""
  },
  {
    operator: "does_not_exists",
    operator_name: "Does not exists",
    fields: [
      "text",
      "textfield",
      "varchar",
      "instance_id",
      "fk",
      "pk",
      "textarea",
      "email",
      "password",
      "radio",
      "selectboxes",
      "select",
      "learning-text",
      "date",
      "checkbox",
      "toggle",
      "datetime",
      "lookup-id",
      "lookup-sm",
      "masterdata-lookup",
      "number",
      "int",
      "currency",
      "id-gen",
      "string"
    ],
    value: ""
  }
];

export function getPrefilterOperatorName(operator) {
  // Search in operatorData
  const operatorObj = operatorData.find((op) => op.operator === operator);

  if (operatorObj) {
    return operatorObj.operator_name;
  }

  // Search in columnOperatorData if not found in operatorData
  const columnOperatorObj = columnOperatorData.find((op) => op.operator === operator);

  if (columnOperatorObj) {
    return columnOperatorObj.operator_name;
  }

  // Return a message if the operator is not found
  return operator;
}

export function getPrefilterOperatorValue(operator) {
  if (!operator) return null;
  const operatorObj = operatorData.find((op) => op.operator === operator);

  if (operatorObj) {
    return operatorObj.value;
  }

  const columnOperatorObj = columnOperatorData.find((op) => op.operator === operator);

  if (columnOperatorObj) {
    return columnOperatorObj.value;
  }

  return null;
}
